export default String.raw`
.check-deligoo {
    .dialog {
        &__header {
            padding: 16px 16px 0 16px;
        
            &-title {
                @include h3-headline;
            }
        }

        &__content {
            padding: 24px 16px 16px 16px;
        }
    }
}
`